<!-- <div class="container">
    <div class="row" style="height: 100vh; align-items: center;">
       <div class="col-md-6 mx-auto mt-5">
          <div class="payment">
             <div class="payment_header">
                <div class="check"><i class="fa fa-check" aria-hidden="true"></i></div>
             </div>
             <div class="content">
                <h1>Payment Success !</h1>
                <p style="padding : 5px">Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. </p>
                <a href="#">Go to Home</a>
             </div>
          </div>
       </div>
    </div>
 </div>  -->

 <!-- <div class="overlay">
    <div class="spinner" *ngIf="loaderCheck"></div>
   
</div> -->

<div class="loader-container">
   <div class="spinner"></div>
   <div class="message">
     Please don't close this screen.<br>
     Redirecting you in <strong>{{ timeLeft }}</strong> seconds.
   </div>
 </div>